import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import HomepageAsset from '../Asset';

export default function CarouselAsset({
  linkEnabled,
  setPaused,
  slide,
  settings,
}) {
  const classNames = useClassName('CLPCarousel');
  const linkUrl = linkEnabled ? slide.fields.url : null;
  const Container = linkUrl ? 'a' : 'div';

  return (
    <Container
      className={classNames(linkUrl ? ['slide', 'slide-link'] : 'slide')}
      {...(linkUrl && { href: linkUrl })}
      {...(!!setPaused && {
        onMouseOver: () => setPaused(true),
        onMouseOut: () => setPaused(false),
      })}>
      <HomepageAsset asset={slide} settings={settings} />
    </Container>
  );
}

CarouselAsset.propTypes = {
  linkEnabled: PropTypes.bool,
  setPaused: PropTypes.func,
  slide: PropTypes.object.isRequired,
  settings: PropTypes.array,
};

CarouselAsset.defaultProps = {
  linkEnabled: false,
  setPaused: null,
  settings: [],
};
